import React from 'react'
import { connect } from 'react-redux'

import ActionButtons from '../../commons/ActionButtons'
import Checkbox from '../../commons/Checkbox'
import NewCommitment from './NewCommitment'
import Commitment from './Commitment'

import {
  getActiveCommitmentIds, getCreditHistory
} from './../../../reducers'

import {
  buildCommitment,
  updateCommitmentsStart,
  creditHistoryChanged,
} from '../../../actions'
import CreditHistory from './Commitment/Form/CreditHistory'

class Commitments extends React.Component {
  state = {
    noCommitment: false,
    continueButtonEnabled: true,
    validationReset: false
  }

  handleNewInput = () => {
    this.setState({validationReset: true, continueButtonEnabled: true})
  }

  componentDidMount() {
    window.scrollTo({top: 0})
  }

  onNewCommitClick = (payload) => {
    this.props.buildCommitment(payload)
  }

  onContinueClick = () => {
    this.setState({ continueButtonEnabled: false })
    this.props.updateCommitmentsStart()
  }

  onCreditHistoryChange = (payload) => {
    this.props.creditHistoryChanged(payload)
  }

  continueEnabled = () => {
    const hasCreditHistory = !!this.props.creditHistory
    if (this.props.commitmentIds.length > 0 || this.state.validationReset) {
      return hasCreditHistory
    }

    return this.state.noCommitment && hasCreditHistory
  }

  renderCommitments() {
    let {
      commitmentIds,
      availableCommitments,
    } = this.props

    return commitmentIds.map((id) => (
      <Commitment
        key={id}
        id={id}
        availableCommitments={ availableCommitments }
        resetValidation={this.handleNewInput}
      />
    ))
  }

  newCommitmentCollapsed() {
    return this.props.commitmentIds.length > 0
  }

  render() {
    const {
      continueButtonEnabled,
      noCommitment
    } = this.state
    return(
      <div>
        <h3>Loan commitments</h3>
        <p className='grey'>If you are currently owing or due to repay one or more of the following options below, please add them with the relevant information.</p>

        <div className='card card-single select-commitment'>
          <div className='card-body'>
            <div className='qn'>Add a current commitment</div>

            { this.renderCommitments() }

            <NewCommitment
              availableCommitments={ this.props.availableCommitments }
              onNewCommitClick={ this.onNewCommitClick }
              collapsed={ this.newCommitmentCollapsed() }
            />
            <br />
            {
              this.props.commitmentIds.length === 0 && (
                <Checkbox
                  checked={ noCommitment }
                  onClick={ () => this.setState({ noCommitment: !noCommitment }) }
                  id='empty-commitment'
                  text="I don't currently have a loan commitment"
                />
              )
            }
          </div>
        </div>

        <CreditHistory
          creditHistory={this.props.creditHistory}
          onClick={ this.onCreditHistoryChange }
        />

        <ActionButtons
          continueEnabled={ this.continueEnabled() && continueButtonEnabled }
          onContinueClick={ this.onContinueClick }
          onGoBackClick={ this.props.onGoBackClick }
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
    creditHistory: getCreditHistory(state),
    commitmentIds: getActiveCommitmentIds(state),
    availableCommitments: state.options.commitments,
    availableCreditHistory: state.options.credit_history,
})

export default connect(mapStateToProps, {
  buildCommitment,
  creditHistoryChanged,
  updateCommitmentsStart,
})(Commitments)
